import React, { useState, useEffect } from 'react';
import "./index.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCurrentUserId } from '../../utils/auth';

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const userId = getCurrentUserId();
    if (!userId) return;

    const notifRef = collection(db, 'notifications', userId, 'user_notifications');
    const unreadQuery = query(notifRef, where('isRead', '==', false));

    const unsubscribe = onSnapshot(unreadQuery, (snapshot) => {
      setUnreadCount(snapshot.docs.length);
    });

    return () => unsubscribe();
  }, []);

  const getActiveStyle = (path) => {
    return location.pathname === path ? { color: '#BF8906', fontWeight: 'bold' } : {};
  };

  return (
    <div className="navbar-container">
      <ul className="navbar-left-menu">
        <li style={getActiveStyle('/cast-crew')} onClick={() => navigate('/cast-crew')}>Cast & Crew</li>
        <li style={getActiveStyle('/other-section-detail')} onClick={() => navigate('/other-section-detail', {
          state: { sectionId: '181', sectionName: 'Lessons', sectionImage: 'dailyNews.png' }
        })}>Lessons</li>
        <li style={location.pathname === '/' && location.state?.scrollToRentals ? { color: '#BF8906', fontWeight: 'bold' } : {}}
          onClick={() => navigate('/', { state: { scrollToRentals: true } })}>Rentals</li>
        <li style={getActiveStyle('/directory')} onClick={() => navigate('/directory')}>Directory</li>
        <li style={getActiveStyle('/craft')} onClick={() => navigate('/craft')}>24 Crafts</li>
        <li style={getActiveStyle('/other-section')} onClick={() => navigate('/other-section')}>Other Sections</li>
        {/* <li style={getActiveStyle('/reels')} onClick={() => navigate('/reels')}>Reels</li> */}
      </ul>
      <ul className="navbar-right-menu">
        <li style={getActiveStyle('/users')} onClick={() => navigate('/users')}>Users</li>
        <li style={getActiveStyle('/followers')} onClick={() => navigate('/followers')}>Followers</li>
        <li style={getActiveStyle('/messages')} onClick={() => navigate('/messages')}>Messages</li>
        <li
          style={{ ...getActiveStyle('/notification'), position: 'relative', display: 'flex', alignItems: 'center' }}
          onClick={() => navigate('/notification')}
        >
          Notifications
          {unreadCount > 0 && (
            <span style={{
              backgroundColor: '#BF8906',
              color: 'white',
              fontSize: '10px',
              fontWeight: 'bold',
              padding: '2px 6px',
              borderRadius: '10px',
              marginLeft: '6px',
              lineHeight: '1'
            }}>
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </li>
        <li style={getActiveStyle('/settings')} onClick={() => navigate('/settings')}>Settings</li>
        <li style={getActiveStyle('/profile')} onClick={() => navigate('/profile')}>Profile</li>
      </ul>
    </div>
  );
};

export default NavBar;